import { CartLinesUpdateEvent } from '@shopify/events';
// Connect custom Strata PDP forms to Horizon's native cart rendering/events.
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.sbp__form')) return;
  const drawer = document.querySelector('#cart-drawer');
  if (!drawer) return; // Native form submission remains the fallback.
  event.preventDefault();
  if (form.dataset.strataBusy === 'true') return;
  if (!form.reportValidity()) return;
  const data = new FormData(form);
  const button = form.querySelector('[data-add]');
  const oldLabel = button?.textContent;
  form.dataset.strataBusy = 'true';
  if (button) { button.disabled = true; button.textContent = 'Adding…'; }
  let error = form.querySelector('.strata-atc-error');
  if (!error) { error = document.createElement('p'); error.className = 'strata-atc-error'; error.setAttribute('role','alert'); form.append(error); }
  error.textContent = '';
  const ids = [...new Set([...document.querySelectorAll('cart-items-component')].map(node => node.dataset.sectionId).filter(Boolean))];
  data.set('sections', ids.join(','));
  data.set('sections_url', location.pathname);
  const pending = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:String(data.get('id')),quantity:Number(data.get('quantity') || 1)}],promise:pending.promise}));
  const root = window.Shopify?.routes?.root || '/';
  let added = false;
  try {
    const response = await fetch(root + 'cart/add.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
    added = true;
    const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
    if (!cartResponse.ok) throw new Error('Cart refresh failed.');
    const cart = await cartResponse.json();
    pending.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'strata-product-form',sections:result.sections,didError:false}});
  } catch (problem) {
    pending.resolve({detail:{didError:true}});
    if (added) { location.assign(root + 'cart'); return; }
    error.textContent = problem.message || 'Unable to add this item. Please try again.';
  } finally {
    delete form.dataset.strataBusy;
    if (button) { button.disabled = false; button.textContent = oldLabel; }
  }
});
